import { Actions } from 'interface/sharedJsInterface';


export const {
  Algolia,
  Assignments,
  BoardExamDates,
  Categories,
  ClinicalPearls,
  Cme,
  CmeCoach,
  CmeTracker,
  DeviceRegisrations,
  ExamTemplates,
  Highlights,
  Hubspot,
  MemberGroups,
  Modal,
  Notes,
  Notifications,
  Offline,
  OrganizationalMemberships,
  Organizations,
  Performance,
  PracticeExam,
  RiskAssessment,
  Reports,
  Responses,
  QuestionBankProducts,
  QuestionBanks,
  Questions,
  Quizzes,
  Session,
  StaticData,
  StrikeThroughs,
  Subscriptions,
  Users,
  v2

} = Actions;
